import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Menu, MenuItem, Toolbar } from '@material-ui/core';
import { PrimeLogon } from '~/assets/img';
import { Expand } from '~/assets/svg';
import { Routing } from '~/routes/routing';
import { Amplify } from '~/services';
import { device } from '~/theme/breakpoints';
import { REACT_APP_PRIME_SSO_URL, useStores } from '~/utils';
import If from '../If';
import {
  Content,
  ImgIcon,
  NameUser,
  SectionIcon,
  SectionLogo,
  SectionToolbar,
  TextProduct
} from './header.styles';

type Props = {
  title: string;
};

const amplify = new Amplify();

const Header: FC<Props> = ({ title }) => {
  const { routing, user } = useStores();
  const [toolbarOpened, setToolbar] = useState(false);
  const [username, setUsername] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
  const loadUserData = async () => {
      try {
        const { username: name } = await amplify.getUsername();
        setUsername(name);
        
        const tenantId = await amplify.getTenantId();
        const adminStatus = await amplify.isUserAdmin(tenantId);
        setIsAdmin(adminStatus);
      } catch (error) {
        console.error('Erro ao carregar dados do usuário:', error);
      }
    };

    loadUserData();
  }, []);

  const handleToolbar = () => {
    setToolbar(!toolbarOpened);
  };

  const handleConfigClick = () => {
    routing.push('/config-form'); 
    setToolbar(false); 
  };

  const onLogout = async () => {
    await amplify.logout();
    if (REACT_APP_PRIME_SSO_URL !== undefined) {
      window.location.href = REACT_APP_PRIME_SSO_URL;
      return null;
    }
  };

  return (
    <Content>
      <SectionLogo>
        <ImgIcon src={PrimeLogon} />
        <TextProduct>{title}</TextProduct>
      </SectionLogo>
      <SectionToolbar>
        <SectionIcon onClick={handleToolbar}>
          <If condition={!device.isMobile}>
            <NameUser>{username}</NameUser>
          </If>
          <Expand />
        </SectionIcon>
        <If condition={toolbarOpened}>
          <Toolbar onClick={handleToolbar}>
            <Menu
              open={toolbarOpened}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              style={{ marginTop: 50, width: 200 }}
            >
              <MenuItem style={{ width: 150 }} onClick={onLogout}>
                Sair
              </MenuItem>
              {isAdmin && (
                <MenuItem style={{ width: 150 }} onClick={handleConfigClick}>
                  Configuração
                </MenuItem>
              )}
            </Menu>
          </Toolbar>
        </If>
      </SectionToolbar>
    </Content>
  );
};

export default observer(Header);
